import { gql } from '@apollo/client'

export const GET_EXPIRATION_TRACKERS = gql`
  query ExpirationTrackers(
    $filters: ExpirationTrackerFiltersInput
    $pageInfo: PageInfoInput
    $orderBy: OrderByInput
  ) {
    expirationTrackers(
      filters: $filters
      pageInfo: $pageInfo
      orderBy: $orderBy
    ) {
      items {
        expirationTrackerId
        label
        category
        expirationDate
        status
        daysRemaining
        applicant {
          applicantId
          firstName
          lastName
          fullName
        }
        nextNotification {
          expirationNotificationId
          scheduledDate
          actionType
          status
        }
      }
      totalCount
      pageInfo {
        offset
        limit
      }
    }
  }
`

export const GET_EXPIRATION_TRACKER = gql`
  query ExpirationTracker($expirationTrackerId: String!) {
    expirationTracker(expirationTrackerId: $expirationTrackerId) {
      expirationTrackerId
      label
      category
      expirationDate
      status
      daysRemaining
      createdAt
      documentId
      document {
        documentId
        fileName
        createdAt
        category
        expirationDate
      }
      applicant {
        applicantId
        firstName
        lastName
        fullName
        isCommunicationOptIn
      }
      createdBy {
        employeeId
        firstName
        lastName
      }
      notifications {
        expirationNotificationId
        status
        offsetDays
        scheduledDate
        actionType
        recipient
        sentAt
        cancelledAt
        failedAt
        errorMessage
      }
      auditTrails {
        auditTrailId
        createdAt
        changeType
        title
        message
        employee {
          employeeId
          firstName
          lastName
        }
      }
    }
  }
`

export const CANCEL_EXPIRATION_NOTIFICATION = gql`
  mutation CancelExpirationNotification(
    $expirationNotificationId: String!
  ) {
    cancelExpirationNotification(
      expirationNotificationId: $expirationNotificationId
    ) {
      expirationNotificationId
      status
      cancelledAt
    }
  }
`

export const RESCHEDULE_EXPIRATION_NOTIFICATION = gql`
  mutation RescheduleExpirationNotification(
    $expirationNotificationId: String!
    $newScheduledDate: DateTime!
  ) {
    rescheduleExpirationNotification(
      expirationNotificationId: $expirationNotificationId
      newScheduledDate: $newScheduledDate
    ) {
      expirationNotificationId
      status
      scheduledDate
    }
  }
`

export const ADD_EXPIRATION_NOTIFICATION = gql`
  mutation AddExpirationNotification(
    $expirationTrackerId: String!
    $input: AddExpirationNotificationInput!
  ) {
    addExpirationNotification(
      expirationTrackerId: $expirationTrackerId
      input: $input
    ) {
      expirationNotificationId
      status
      scheduledDate
      actionType
      recipient
    }
  }
`

export const SYNC_EXPIRATION_NOTIFICATIONS = gql`
  mutation SyncExpirationNotifications($expirationTrackerId: String!) {
    syncExpirationNotifications(expirationTrackerId: $expirationTrackerId) {
      expirationTrackerId
    }
  }
`

export const RENEW_EXPIRATION_TRACKER = gql`
  mutation RenewExpirationTracker($expirationTrackerId: String!) {
    renewExpirationTracker(expirationTrackerId: $expirationTrackerId) {
      expirationTrackerId
      status
    }
  }
`

export const CANCEL_EXPIRATION_TRACKER = gql`
  mutation CancelExpirationTracker($expirationTrackerId: String!) {
    cancelExpirationTracker(expirationTrackerId: $expirationTrackerId) {
      expirationTrackerId
      status
    }
  }
`

export const ARCHIVE_EXPIRATION_TRACKER = gql`
  mutation ArchiveExpirationTracker($expirationTrackerId: String!) {
    archiveExpirationTracker(expirationTrackerId: $expirationTrackerId) {
      expirationTrackerId
      status
    }
  }
`

export const UPDATE_EXPIRATION_TRACKER = gql`
  mutation UpdateExpirationTracker(
    $expirationTrackerId: String!
    $input: UpdateExpirationTrackerInput!
  ) {
    updateExpirationTracker(
      expirationTrackerId: $expirationTrackerId
      input: $input
    ) {
      expirationTrackerId
      expirationDate
      label
      category
    }
  }
`

export const CREATE_EXPIRATION_TRACKER = gql`
  mutation CreateExpirationTracker($input: CreateExpirationTrackerInput!) {
    createExpirationTracker(input: $input) {
      expirationTrackerId
      label
      status
    }
  }
`

export const CREATE_TRACKER_FOR_DOCUMENT = gql`
  mutation CreateTrackerForDocument($documentId: String!) {
    createTrackerForDocument(documentId: $documentId) {
      expirationTrackerId
      label
      status
    }
  }
`
